import { render } from "./DetalhesReclamacaoTecnica.vue?vue&type=template&id=6ab28f18&scoped=true"
import script from "./DetalhesReclamacaoTecnica.vue?vue&type=script&lang=js"
export * from "./DetalhesReclamacaoTecnica.vue?vue&type=script&lang=js"

import "./DetalhesReclamacaoTecnica.vue?vue&type=style&index=0&id=6ab28f18&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab28f18"]])

export default __exports__